export const ServerConfig = {
    API_URL: process.env.VUE_APP_API_URL || '/api',
    SOCKET_URL: process.env.VUE_APP_SOCKET_URL || '/api',
    HOST_URL: process.env.VUE_APP_HOST_URL,
    SLACK: {
        CLIENT_ID: process.env.VUE_APP_SLACK_CLIENT_ID
    },
    LINE: {
        CLIENT_ID: process.env.VUE_APP_LINE_CLIENT_ID
    }
}
